// extracted by mini-css-extract-plugin
module.exports = {"footerTopGrid":"footer_footerTopGrid__yG_p3"};